import { render, staticRenderFns } from "./LiveDataRecord.vue?vue&type=template&id=77403180&scoped=true"
import script from "./LiveDataRecord.vue?vue&type=script&lang=js"
export * from "./LiveDataRecord.vue?vue&type=script&lang=js"
import style1 from "./LiveDataRecord.vue?vue&type=style&index=1&id=77403180&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77403180",
  null
  
)

export default component.exports